import { GetFragmentDto } from '../../../../apps/app/src/modules/fragments/fragment.types';
import { Segment } from '../domain/segments';
import { rangeDuration } from './datetime';

export function getMaxWidthForWaveform(segments: readonly Segment[]) {
  return (
    segments.reduce((previousValue, currentValue) => {
      return previousValue + currentValue.waveform.length;
    }, 0) -
    segments.length * 2
  );
}

export function getMaxWidthForFragmentWaveform(
  fragment: GetFragmentDto,
  segments: readonly Segment[],
) {
  if (!segments.length) {
    return 0;
  }

  const fullWidth = getMaxWidthForWaveform(segments);
  const fullDuration = segments[segments.length - 1].endTs - segments[0].startTs;

  return fullWidth * (rangeDuration(fragment.from, fragment.to) / fullDuration);
}
